import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.496",
      d: "M15.797 13.587a3.787 3.787 0 0 0 .284-7.43.34.34 0 0 1-.24-.278A5.365 5.365 0 0 0 5.423 4.616a.32.32 0 0 1-.29.177 4.43 4.43 0 0 0-.916 8.68M10 10.692V19"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.496",
      d: "m7.23 13.462 2.77-2.77 2.77 2.77"
    }, null, -1)
  ])))
}
export default { render: render }